export default "__VITE_ASSET__0c7ac895__"